import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CommonSharedModule } from '@ecosure-suite/common/shared';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardCoreComponent } from './containers';
import {
  DASHBOARD_ITEMS_CONFIGURATION_TOKEN,
  DashboardItemsConfigurationToken
} from './tokens';

export const backOficeDashboardRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardCoreComponent,
    data: {
      title: 'Dashboard'
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    CommonSharedModule,
    RouterModule,
    TranslateModule.forChild()
  ],
  declarations: [DashboardCoreComponent]
})
export class BackOfficeDashboardShellModule {
  static forRoot(
    dashboardItems: DashboardItemsConfigurationToken
  ): ModuleWithProviders {
    return {
      ngModule: BackOfficeDashboardShellModule,
      providers: [
        {
          provide: DASHBOARD_ITEMS_CONFIGURATION_TOKEN,
          useValue: dashboardItems
        }
      ]
    };
  }
}
``